import { render, staticRenderFns } from "./KegCreateSingleModal.vue?vue&type=template&id=0c2856ba&scoped=true"
import script from "./KegCreateSingleModal.vue?vue&type=script&lang=js"
export * from "./KegCreateSingleModal.vue?vue&type=script&lang=js"
import style0 from "./KegCreateSingleModal.vue?vue&type=style&index=0&id=0c2856ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2856ba",
  null
  
)

export default component.exports